/**
 * Gets dynamic styles for the option content container.
 * Background/hover are applied on the outer .MuiAutocomplete-option so the
 * highlight spans the full row (MUI already wraps this content in an <li>).
 * @param {boolean} _isSelected - Whether the option is selected (unused; kept for API)
 * @param {boolean} _isFirstOption - Whether this is the first option (unused; kept for API)
 * @returns {Object} - Style object for the option container
 */
export const getOptionStyles = (_isSelected, _isFirstOption) => {
  return {
    display: 'flex',
    padding: '10px 20px 6px',
    marginTop: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderBottom: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
  };
};

/**
 * Gets styles for the option details typography
 * @returns {Object} - Style object for the typography component
 */
export const getOptionDetailsStyles = () => {
  return {
    color: 'var(--Greyscale---grey-110, #333)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.28px',
    marginLeft: '24px',
  };
};
